import { Link } from "react-router-dom";
import { studentWorkspacePaths } from "@/utils/student-workspace";

export function ReportSourceError({
  studentId,
  title,
  description,
  returnTo,
  returnLabel = "返回报告",
}: {
  studentId: string;
  title: string;
  description: string;
  returnTo?: string;
  returnLabel?: string;
}): JSX.Element {
  return (
    <section className="rounded-2xl border border-red-200 bg-red-50 p-8 text-center shadow-sm">
      <h1 className="text-xl font-semibold text-red-800">{title}</h1>
      <p className="mt-2 text-sm text-red-700">{description}</p>
      <Link
        to={returnTo ?? studentWorkspacePaths.reports(studentId)}
        className="mt-5 inline-flex min-h-11 items-center justify-center rounded-lg bg-brand px-5 text-sm font-semibold text-white hover:bg-brand-dark focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand focus-visible:ring-offset-2"
      >
        {returnLabel}
      </Link>
    </section>
  );
}
